"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var change_emitter_1 = require("change-emitter");
var createWithTweekValues_1 = require("./createWithTweekValues");
var createUseTweekValue_1 = require("./createUseTweekValue");
var utils_1 = require("./utils");
exports.createTweekContext = function (defaultRepo) {
    var keysToPrepare = [];
    var emitter = change_emitter_1.createChangeEmitter();
    emitter.listen(function (key) {
        defaultRepo && defaultRepo.prepare(key);
        keysToPrepare.push(key);
    });
    var TweekContext = react_1.default.createContext(defaultRepo);
    TweekContext.displayName = 'TweekContext';
    var Provider = (function (_super) {
        __extends(Provider, _super);
        function Provider(props) {
            var _this = _super.call(this, props) || this;
            _this.prepare = function (key) {
                var value = _this.props.value;
                value && value.prepare(key);
            };
            keysToPrepare.forEach(_this.prepare);
            _this.dispose = emitter.listen(_this.prepare);
            return _this;
        }
        Provider.prototype.componentDidUpdate = function (prevProps) {
            if (this.props.value !== prevProps.value) {
                keysToPrepare.forEach(this.prepare);
            }
        };
        Provider.prototype.componentWillUnmount = function () {
            this.dispose();
        };
        Provider.prototype.render = function () {
            return react_1.default.createElement(TweekContext.Provider, __assign({}, this.props));
        };
        return Provider;
    }(react_1.Component));
    function useTweekRepository() {
        utils_1.ensureHooks();
        return react_1.default.useContext(TweekContext);
    }
    return {
        Provider: Provider,
        Consumer: TweekContext.Consumer,
        prepareKey: emitter.emit,
        withTweekValues: createWithTweekValues_1.createWithTweekValues(TweekContext, emitter.emit),
        useTweekRepository: useTweekRepository,
        useTweekValue: createUseTweekValue_1.createUseTweekValue(TweekContext, emitter.emit),
    };
};
//# sourceMappingURL=createTweekContext.js.map


// WEBPACK FOOTER //
// ../src/createTweekContext.tsx